export default "__VITE_ASSET__DPIVuINa__"